
$(function() {
// Mobile Detection
/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 *
 * jQuery.browser.mobile will be true if the browser is a mobile device
 *
 **/
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

  
	// Newsletter Pop-up
	// Newsletter Pop-up
	function getCookie(c_name)
		{
		var c_value = document.cookie;
		var c_start = c_value.indexOf(" " + c_name + "=");
		if (c_start == -1)
			{
				c_start = c_value.indexOf(c_name + "=");
			}
		if (c_start == -1)
			{
				c_value = null;
			}
		else
			{
			c_start = c_value.indexOf("=", c_start) + 1;
			var c_end = c_value.indexOf(";", c_start);
			if (c_end == -1)
				{
					c_end = c_value.length;
				}
					c_value = unescape(c_value.substring(c_start,c_end));
				}
			return c_value;
		}

		function setCookie(c_name,value,exdays)
		{
		var exdate=new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
		document.cookie=c_name + "=" + c_value;
		}


		window.onload = function checkCookie()
		{
		var newsletter=getCookie("ampnewsletter");
		if (newsletter!=null && newsletter!="")
		  {
		      
		  }
		else
		  {
		    var newsletter = function(){
		    $('#newsletter-modal').modal('show');
		  }
		    setTimeout(newsletter, 5000);
		    setCookie("ampnewsletter",'true',50);
		  }
		}

	// Mega menu toggleing
	// Vars
	mainNavBtn = $('#main-nav li a'),
	menuBtn = $('.mega-menu .sub-menu li a'),

	// Toggle Mega from the top nav items
	// On menu item hover, toggle the mega menu associated with the data-mega attr. 
	// On init, activate the first mega sub-menu item and it's corresponding mega menu.
	$(mainNavBtn).hover(function(){
		menuClass = $(this).attr('data-mega-main'),
		thisMega = $('.mega-menu.'+menuClass),
		firstMenuItem = $(thisMega).find('.sub-menu li').eq(0).children('a'),
		firstMegaMenu = $(thisMega).find('.mega-menu-outer .mega-inner').eq(0);

		$(thisMega).add(firstMenuItem).add(firstMegaMenu).addClass('active');
	}, function(){
		var hovered;
		hovered = false;

		$(thisMega).mouseenter(function(){
			hovered = true;
			$(thisMega).add(firstMenuItem).add(firstMegaMenu).addClass('active');
		}).mouseleave(function(){
			hovered = false;
			$('.mega-menu, .mega-inner').add(menuBtn).removeClass('active');
		});
		if (hovered == false){
			$(thisMega).add(menuBtn).add('.mega-inner').removeClass('active');
		}
	});
	
	// Mega Sub-Menu items toggle active
	// When hovering on a sub-menu item add the calss of active to the sub menu item and corresponding mega menu. 
	// When hovering over the mega menu portion, leave the active class on the sub-menu item you're viewing.
	$(menuBtn).hover(function(){
		menuClass = $(this).attr('data-mega'),
		menuSub = $('.mega-menu .mega-inner.'+menuClass);

		$('.mega-menu .mega-inner').add(menuBtn).removeClass('active');
		$(menuSub).addClass('active');
		
	}, function() {
		isHovered = $('.mega-menu .mega-inner.'+menuClass+':hover');

		if (isHovered){
			$('.mega-menu .sub-menu li a[data-mega='+menuClass+']').addClass('active');
		}
	});

	// Home Page slider menu
	$('#amp-slider .slides').fadeIn(2000).bxSlider({
		// pager: false,
		touchEnabled: false,
		auto: true,
        autoHover: true,
		mode: 'fade',
      	speed: 600,
		controls: false
	});
  
  	$('.logo-bxslider').bxSlider({
      pager: false,
      controls: false,
      auto: true,
      autoHover: true,
      minSlides: 5,
      maxSlides: 5,
      slideWidth: 360,
      slideMargin: 10,
      moveSlides: 1
    });
 
// Staff sliders
	$('#staff-photos .slider').slick({
        centerMode: true,
      	speed: 1000,
      	asNavFor: '#staff-info .slider',
        infinite: true,
        arrows: false,
      	draggable: false,
        centerPadding: '0px',
        slidesToShow: 3,
        responsive: [{
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }],
      	onInit: function() {
        	$('#staff-photos').css('height', 'auto');
      	}
    });
    $('#staff-info .slider').slick({
      	speed: 1000,
    	asNavFor: '#staff-photos .slider',
      	appendArrows: '#staff .slider-controls',
      	prevArrow: '<span class="icon prev icon-thin-arrow-left" title="Previous"></span>',
      	nextArrow: '<span class="icon next icon-thin-arrow-right" title="Next"></span>',
        fade: true,
  		cssEase: 'linear',
      	draggable: false,
      	swipe: false,
        onInit: function() {
        	$('#staff-info').css('height', 'auto');
      	}
    });

	// Product Grid
	/* removed opacity hover effect
    var productLink = $('#product-grid .product a');
	var featuredProd = $('.product-detail .featured-products .product a');
	$('#product-grid .product a img, .product-detail .featured-products .product a img').css({'opacity' : .8});

	$(productLink).add(featuredProd).hover(function(){
		$(this).find('img').stop(true, true).animate({'opacity' : 1}, 200);
	}, function(){
		$(this).find('img').stop(true, true).animate({'opacity' : .8}, 200);
	});*/
  	$('.sidebar .collections > li.has-sub > a').click(function(e){
		e.preventDefault();
      	$(this).next('.sub-menu').stop(true, true).slideToggle(200, function(){
			if( $(this).is(":hidden") ){
				$(this).prev('a').removeClass('active');
				$(this).siblings('a').find('.icon').toggleClass('icon-arrow-down icon-arrow-right');
			} else if( $(this).is(":visible") ) {
				$(this).prev('a').addClass('active');
				$(this).siblings('a').find('.icon').toggleClass('icon-arrow-right icon-arrow-down');
			}
		});
    });
  

  
  
  
	/*
    $('.sidebar .collections li a .icon').click(function(e){
		e.preventDefault();
		$(this).next('.sub-menu').stop(true, true).slideToggle(200, function(){
			if( $(this).is(":hidden") ){
				$(this).prev('a').removeClass('active');
				$(this).siblings('a').find('.icon').removeClass('icon-arrow-down').addClass('icon-arrow-right');
			} else if( $(this).is(":visible") ) {
				$(this).prev('a').addClass('active');
				$(this).siblings('a').find('.icon').removeClass('icon-arrow-right').addClass('icon-arrow-down');
			}
		});
	});
  */

	// Sub Collection Pages Indicator
	var activeCollection = $('.sidebar .collections li a.active');
	if ( $(activeCollection) ){
		$(activeCollection).children('.icon').removeClass('icon-arrow-right').addClass('icon-arrow-down');
	}

 	// Product Detail Back to Top button
 	$(window).scroll(function(){
 		// console.log($(window).scrollTop());
 		var topPos = $(window).scrollTop();
 		if(topPos >= 600){
 			$('#back-to-top').show('fast');
 		} else{
 			$('#back-to-top').hide('fast');
 		}
 	});
 	$('#back-to-top .top-button').click(function(){
 		$('body,html').animate({scrollTop: 0}, 500);
 	});

	// Shopify Tag Filtering & ezMark custom input checkboxes
	$('.collections-filter input[type="checkbox"], #registry-dashboard-sort input[type="checkbox"]').ezMark({
		checkboxCls: 'icon-radio-unchecked',
		checkedCls: 'icon-radio-checked'
	});

	$('#content a.filter').click(function(e){
		e.preventDefault();
		$(this).siblings('.collections-filter, .filter-dropdown').slideToggle(300, function(){
			degree = 180;
			$('#content a.filter .icon').animate({
                        '-webkit-transform': 'rotate(' + degree + 'deg)',
                        '-moz-transform': 'rotate(' + degree + 'deg)',
                        '-ms-transform': 'rotate(' + degree + 'deg)',
                        '-o-transform': 'rotate(' + degree + 'deg)',
                        'transform': 'rotate(' + degree + 'deg)',
                        'zoom': 1
            }, 500);
		});
	});


	// Quick View Product Modal
	$('#product-grid .product .quick-view').css({opacity : 0});
	$('#product-grid .product .product-img').hover(function(){
		var imgW = $(this).find('img').width();
		var imgH = $(this).find('img').height();
		$(this).find('.quick-view').css({
			'max-width' : imgW+'px'
		});
		$(this).find('.quick-view').stop(true, true).animate({opacity : 1}, 200);
	}, function(){
		$(this).find('.quick-view').stop(true, true).animate({opacity : 0}, 200);
	});

	// Shopify Registry form ezMark custom input checkboxes
	$('.registry-step-two input[type="checkbox"]').ezMark({
		checkboxCls: 'icon-checkbox-unchecked',
		checkedCls: 'icon-checkbox-checked'
	});
	$('#wedding-date, #shipping-date').datepicker({
	  format: 'yyyy-mm-dd',
	  autoclose: true
	});

	$('.registry-step-two .fieldset-title .pop-over, .registry-step-two .input-with-tooltip .pop-over').popover({
		placement: 'bottom',
		trigger: 'click',
		html: true,
		content: function(){
            return $(this).attr("data-pop-over-content");
		}
	});

	// Registry App Dashboard
	 $('.registry-dashboard .purchase-details > .col-title .icon-arrow-down').click(function(){
	 	$(this).parent().next('.purchase-content').slideToggle(300, function(){
	 		var theIcon = $(this).siblings('.col-title').children('span');
	 		if( $(theIcon).hasClass('icon-arrow-down') ){
	 			$(theIcon).removeClass('icon-arrow-down').addClass('icon-arrow-up');
	 		} else if ( $(theIcon).hasClass('icon-arrow-up') ) {
	 			$(theIcon).removeClass('icon-arrow-up').addClass('icon-arrow-down');
	 		}
	 	});
	 });

	 $('.registry-dashboard .product-info .note-for-guests').click(function(){
	 	var topPos = $(this).parent('.product-info').height();
	 	$(this).siblings('.popover').css({'top' : (topPos+5)+'px'}).toggle(150, function(){
		 	$(this).find('.cancel').click(function(e){
		 		e.preventDefault();
		 		$(this).parent().parent('.popover').hide(150);
		 	});
	 		
	 	});
	 });
 
	 // List View / Collage View
	 $('.registry-dashboard #dashboard-views ul li a').click(function(e){
	 	e.preventDefault();
	 	if( $(this).hasClass('collage-view') ){
	 		$('.registry-dashboard #dashboard-views ul li a').removeClass('active');
	 		$(this).addClass('active');
	 		$('#inner-content').addClass('collage');
	 	} else {
	 		$('.registry-dashboard #dashboard-views ul li a').removeClass('active');
	 		$(this).addClass('active');
	 		$('#inner-content').removeClass('collage');
	 	}
	 });

	 // Dashboard Quick View Image Modal
	 if (jQuery.browser.mobile == false){
		 $('.registry-dashboard .product-img .product-img-link').click(function(e){
		 	e.preventDefault();
		 	var quickViewImg = $(this).attr('data-quick-view');
		 	console.log(quickViewImg);
		 	$('#dashboard-quick-view .modal-body img').attr('src', quickViewImg);
		 	$('#dashboard-quick-view').modal('show');
		 });
	 }

	// Product Detail Image Switcher
 	$('.product-detail .product-thumbs a').click(function(e){
 		e.preventDefault();
 		$('.product-detail .product-img, .product-detail .product-img .zoom').trigger('zoom.destroy');
 		var mainImg = $('.product-detail #main .product-img img'),
 		dataNewImg = $(this).attr('data-alt-prod-img'),
 		dataNewImgZoom = $(this).attr('data-alt-prod-img-zoom');
 		console.log(dataNewImgZoom);

 		$(mainImg).attr('src', dataNewImg);
 		$(mainImg).parent().attr('data-product-img', dataNewImgZoom);
 		zoomThis();
 		$('img.zoomImg').attr('src', dataNewImg);
 	});

  
	// Product Page Zoom Feature
	var zoomThis = function(){
		var largeImg = $('.product-detail .product-img').attr('data-product-img');
		$('.product-detail .product-img, .product-detail .product-img .zoom').zoom({
			url: largeImg,
			on: 'hover'
		});
	}
	zoomThis();

	if(jQuery.browser.mobile == true){
		// Mobile Device Zooming
		Hammer('.product-detail .product-img, .product-detail .product-img .zoom').on("touch", function() {
	    	zoomThis();
		});
	}
  
  
    /* Extracted from Registry app
       - Error handling
       - Button notifications
       - Form validation
    */

  	// Error handling
    var bottomFlash, bottomFlashError, bottomFlashWarning, bottomFlashSuccess, bottomFlashMessage, bottomFlashClear;

    bottomFlash = function(message, opts) {
      var defaultCancel, defaultConfirm, defaultOut, errors, out, options, confirm, cancel, fade, notification;

      errors = $('#error-log .error-list');

      defaultOut     = function() { errors.fadeOut().hide().empty() }
      defaultConfirm = defaultOut;
      defaultCancel  = defaultOut;

      options = (typeof opts !== "undefined" && opts !== null) ? opts : {}
      
      confirm = (typeof options.confirm == "function") ? options.confirm : defaultConfirm;
      cancel  = (typeof options.cancel  == "function") ? options.cancel  : defaultCancel;
      out     = (typeof options.out     == "function") ? options.out     : defaultOut;
      fade    = options.fade == false ? false : true;
      
      notification = $(message)      
      notification.find(".confirm").on("click", confirm)
      notification.find(".cancel").on("click", cancel)
            
      errors.hide().empty().append(notification).show();
      
      if (fade) {
        setTimeout(out, 10000);
      }
    };

    bottomFlashError = function(message, options) {
      if (message == null) {
        message = "There were errors in the form";
      }
      return bottomFlashMessage(message, "error", "icon-bs-exclamation-sign", options);
    };

    bottomFlashWarning = function(message, options) {
      if (message == null) {
        message = "There were problems in the form";
      }
      return bottomFlashMessage(message, "warning", "icon-bs-warning-sign", options);
    };
  
    bottomFlashSuccess = function(message, options) {
      if (message == null) {
        message = "Success";
      }
      bottomFlashMessage(message, "success", "", options);
    };
  
    bottomFlashMessage = function(message, alertType, iconClass, options) {
      var li = '<li class="alert-'+alertType+'"><span class="'+iconClass+'"></span> '+message+'</li>'
      return bottomFlash(li, options);
    };

    bottomFlashClear = function() {
      return $('#error-log .error-list').empty();
    };

 	// Button Notifications 
    var buttonNotify;
  
    buttonNotify = function(el, message, opts) {
      var button, callback, changeMessageAndPreserveSize, duration, height, options, originalColor, originalMessage, replaceMessage, restore, width;

      if (message == null) {
        message = "successful";
      }
      options = (typeof opts !== "undefined" && opts !== null) ? opts : {}
      duration = parseInt(options.duration) || 2000;
      callback = options.callback;
      
      button = $(el).closest(".black-button, .gray-button");
      width = button.width();
      height = button.height();
      changeMessageAndPreserveSize = function (el, msgFunc, msg) {
        if (msgFunc(el, msg).width(width).height() > height) {
          el.width("auto")
        }
      };
      if (button.html() != '') {
        originalMessage = button.html();
        replaceMessage = function(el, msg) { return el.html(msg); };
      } else {
        originalMessage = button.val();
        replaceMessage = function(el, msg) { return el.val(msg); };
      }
      originalColor = button.css("background-color");
      changeMessageAndPreserveSize(button, replaceMessage, message)
      button.css("background-color", "#32a206");
      restore = function() {
        changeMessageAndPreserveSize(button, replaceMessage, originalMessage)
        button.css("background-color", originalColor);
        return typeof callback === "function" ? callback() : void 0;
      };
      setTimeout(restore, duration);
    };

  
	// Form validations
    var nonPlaceholderValue, clearValueIfUnedited, resetValue, hasPlaceholderValue, clearUneditedOptionalInputs, addPlaceholders, bottomDisplayValidationErrors, validateRequiredInputs;
 
    nonPlaceholderValue = function(el) {     
      if (!hasPlaceholderValue(el)) {
        return el.val();
      }
      return '';
    };

    clearValueIfUnedited = function(el) {
      if (hasPlaceholderValue(el)) {
        return el.val('');
      }
    };

    resetValue = function(el) {
      if (el.attr("data-default")) {
        return el.val(el.attr("data-default"));
      }
    };

    hasPlaceholderValue = function(el) {
      if (el.attr("placeholder")) {
        return el.val() === "";
      }
      // Delete the rest if using placeholder attribute
      if (el.attr("data-default") && el.val() === el.attr("data-default")) {
        return true;
      }
      if ($("select").filter(el).length > 0 && el.attr("data-prompt") && el.val() === '') {
        return true;
      }
      return false;
    };

    clearUneditedOptionalInputs = function(form) {
      var optionals;

      optionals = $("input").add("select").add("textarea").filter("[data-default]").not(".required");
      optionals.each(function(i, el) {
        return clearValueIfUnedited($(el));
      });
      return true;
    };

    addPlaceholders = function(container) {
      elements = $(container).find("input").add("textarea").add("select")
      elements.filter("[placeholder]").val('')
      return elements.not("[placeholder]").each(function(i, el) {
        return resetValue($(el));
      });
    };

    bottomDisplayValidationErrors = function(errors) {
      var e, _i, _len;

      bottomFlashClear();
      for (_i = 0, _len = errors.length; _i < _len; _i++) {
        e = errors[_i];
        $(e.el).addClass("error").addClass("new");
        bottomFlashError();
      }
      $(".error").not(".new").removeClass("error");
      return $(".error.new").removeClass("new");
    };

    validateRequiredInputs = function(form) {
      var errors, required;

      required = $(form).find(".required");
      errors = [];
      required.each(function(i, el) {
        if (hasPlaceholderValue($(el))) {
          return errors.push({
            el: $(el),
            name: $(el).attr("data-prompt"),
            message: "is required"
          });
        }
      });
      return errors;
    };
  
    // Exports
    window.Registry = (typeof window.Registry !== 'undefined' && window.Registry !== null) ? window.Registry : {};
    window.Registry.buttonNotify = buttonNotify;
    window.Registry.validateRequiredInputs = validateRequiredInputs;
    window.Registry.clearUneditedOptionalInputs = clearUneditedOptionalInputs;
    window.Registry.addPlaceholders = addPlaceholders;
    window.Registry.nonPlaceholderValue = nonPlaceholderValue;
    window.Registry.bottomDisplayValidationErrors = bottomDisplayValidationErrors;
    window.Registry.bottomFlashError = bottomFlashError;
    window.Registry.bottomFlashWarning = bottomFlashWarning;
    window.Registry.bottomFlashSuccess = bottomFlashSuccess;
    if (typeof addToRegistry !== 'undefined') {
      window.Registry.addToRegistry = addToRegistry;
    }

    // Activate placeholder shim for ie9
    $('input, textarea').placeholder();
});



$( window ).load(function() {
  //$( "#product-grid, #inner-content hr" ).fadeIn(2000);
  $( "#product-grid" ).fadeIn(2000);
});
